import fetcher from '../utils/api';

const workOsGroupService = {
  listAllWorkOsGroups: async () => fetcher(`admin/workos_directory_group/`, 'GET', true),
  setGroupSystemAdminRoleWithOrg: async (groupId, organizationId) =>
    fetcher(`admin/workos_directory_group/${groupId}/set-system-admin/`, 'PUT', true, {
      organization: organizationId
    }),
  createGroupOrgPermission: async (groupId, permission_level, organizationId) =>
    fetcher(`admin/workos_directory_group/${groupId}/organization_permissions/`, 'POST', true, {
      permission_level,
      organization: organizationId
    }),
  deleteGroupFromOrg: async (groupId, groupRoleId) =>
    fetcher(`admin/workos_directory_group/${groupId}/organization_permissions/${groupRoleId}/`, 'DELETE', true),
  changeGroupPermissionInOrg: async (groupId, groupRoleId, newPermissionLevel) =>
    fetcher(`admin/workos_directory_group/${groupId}/organization_permissions/${groupRoleId}/`, 'PATCH', true, {
      permission_level: newPermissionLevel
    })
};

export default workOsGroupService;
